import { getSharingTooltipMessage } from '../utils/sharing-utils';
import * as i0 from "@angular/core";
/**
 * Returns the sharing tooltip message string for the given item.
 *
 * @param item - The item for which to generate the sharing tooltip message.
 * @returns The sharing tooltip message string.
 */
export class GetSharingTooltipMessage {
    transform(item) {
        return getSharingTooltipMessage(item);
    }
}
GetSharingTooltipMessage.ɵfac = function GetSharingTooltipMessage_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GetSharingTooltipMessage)(); };
GetSharingTooltipMessage.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "getSharingTooltipMessage", type: GetSharingTooltipMessage, pure: true, standalone: false });
